import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BaseLayerId } from '../../models/base-layer.model';
import { ObserverMapFacadeService } from '../../services/observer-map-facade.service';

@Component({
  selector: 'app-settings-menu',
  templateUrl: './settings-menu.component.html',
  styleUrl: './settings-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsMenuComponent {
  protected readonly facade = inject(ObserverMapFacadeService);

  protected updateReplayDateTime(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.facade.setReplayDateTimeInput(input.value);
  }

  protected updateReplaySpeed(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const nextSpeed = Number(select.value);

    this.facade.setReplaySpeed(nextSpeed);
    select.value = String(this.facade.replaySpeed());
  }

  protected updateBaseLayer(event: Event): void {
    const input = event.target as HTMLInputElement;
    const nextBaseLayer = input.value;

    if (this.isBaseLayerId(nextBaseLayer)) {
      this.facade.setBaseLayer(nextBaseLayer);
    }
  }

  protected updateRefreshInterval(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = String(this.facade.setRefreshIntervalMs(Number(input.value)));
  }

  protected updateDroneLayerVisibility(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.facade.setDroneLayerVisible(input.checked);
  }

  protected updateDroneLookbackSeconds(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = String(this.facade.setDroneLookbackSeconds(Number(input.value)));
  }

  protected updateDroneStaleAfter(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = String(this.facade.setDroneStaleAfterMs(Number(input.value)));
  }

  private isBaseLayerId(value: string): value is BaseLayerId {
    return value === 'osm' || value === 'ortho';
  }
}
